import { Checkbox, Table, TableTdProps } from '@mantine/core';
import clsx from 'clsx';
import { useStoreMap, useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { RegistryModel, Row } from 'shared/lib';

export type RegistryTableTdCheckboxProps = TableTdProps & { rowId: number };

export const createRegistryTableTdCheckbox = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
>(
	model: RegistryModel<TRow, TFilters, TError>,
) => {
	const RegistryTableTdCheckbox = forwardRef<HTMLTableCellElement, RegistryTableTdCheckboxProps>(
		({ rowId, className, onClick, ...props }, ref) => {
			const selected = useStoreMap({
				store: model.selection.$value,
				keys: [rowId],
				fn: (sel, [id]) => (id ? sel.includes(id) : null),
			});

			const toggle = useUnit(model.rowToggled);

			return (
				<Table.Td
					ref={ref}
					className={clsx('registry-table-td-checkbox', className)}
					{...props}
				>
					<Checkbox
						data-test-id='registry-table-td-checkbox'
						checked={selected || false}
						onChange={() => toggle(rowId)}
					/>
				</Table.Td>
			);
		},
	);

	return RegistryTableTdCheckbox;
};
